<template>
	<div
		ref="error-message"
		class="p-3"
		:class="classes"
		style="display: none; opacity: 1"
		:style="style"
	>
		<span v-html="data.text"></span>
		<button class="cls" @click.stop="handleClose">
			<span>x</span>
		</button>
	</div>
</template>

<script>
export default {
	name: "ErrorMessage",
	props: {
		textColor: {
			type: String,
			default: "black",
		},
		backgroundColor: {
			type: String,
			default: "rgba(255,155,155,0.92)",
		},
		border: {
			type: String,
			default: "none",
		},
		text: String,
		selfDestructTime: {
			type: Number,
			default: 5000,
		},
		position: {
			type: String,
			default: "fixed",
		},
		bottom: {
			type: String,
			default: "0px",
		},
		right: {
			type: String,
			default: "0px",
		},
		zIndex: {
			type: String,
			default: "3000",
		},
		maxWidth: {
			type: String,
			default: "600px",
		},
		transition: {
			type: String,
			default: "opacity 250ms ease-in-out",
		},
		borderRadius: {
			type: String,
			default: "8px",
		},
		margin: {
			type: String,
			default: "13px",
		},
		classes: {
			type: String,
			default: "",
		},
		fadeTimeOut: {
			type: Number,
			default: 250,
		},
	},
	data() {
		return {
			data: {
				text: "",
				timerStart: null,
			},
		};
	},
	computed: {
		style() {
			return {
				color: this.textColor,
				background: this.backgroundColor,
				border: this.border,
				position: this.position,
				bottom: this.bottom,
				right: this.right,
				zIndex: this.zIndex,
				maxWidth: this.maxWidth,
				transition: this.transition,
				borderRadius: this.borderRadius,
				margin: this.margin,
			};
		},
	},
	methods: {
		fadeIn() {
			this.$refs["error-message"].style.display = "block";
			this.$refs["error-message"].style.opacity = 1;
		},
		fadeOut() {
			this.$refs["error-message"].style.opacity = 0;
			setTimeout(() => {
				this.$refs["error-message"].style.display = "none";
			}, this.fadeTimeOut);
		},
		handleClose() {
			this.$emit("close");
		},
	},

	watch: {
		text: function (newValue, oldValue) {
			this.$set(this.data, "timerStart", Date.now());

			const interval = setInterval(() => {
				if (Date.now() - this.data.timerStart < this.selfDestructTime) return;

				clearInterval(interval);
				this.$emit("close");
			}, 500);

			if (newValue && !oldValue) {
				this.$set(this.data, "text", newValue);
				this.fadeIn();
			} else if (!newValue && oldValue) {
				this.fadeOut();
			} else {
				this.$set(this.data, "text", newValue);
			}
		},
	},
};
</script>

<style scoped>
.cls {
	position: absolute;
	top: 0;
	right: 0;
	background: transparent;
	border-radius: 50%;
	border: none;
	touch-action: manipulation;
}
</style>
